// removed by extract-text-webpack-plugin
module.exports = {"cont":"Gallery__cont___1j2ZL","imagesCont":"Gallery__imagesCont___2sClk","images":"Gallery__images___1gxp1","image":"Gallery__image___3fAHG","first":"Gallery__first___2ugI3","img":"Gallery__img___3TCNw","description":"Gallery__description___354QD","leftArrow":"Gallery__leftArrow___2rqxz","rightArrow":"Gallery__rightArrow___2z6ry","heroTitle":"Gallery__heroTitle___TBNTc","heroYear":"Gallery__heroYear___1-hCv","heroRoomNumber":"Gallery__heroRoomNumber___27s3P","enterButton":"Gallery__enterButton___2h_Jj"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/Tour/Gallery/Gallery.css
// module id = 756
// module chunks = 0